import ACTION from '../actionTypes';

const initialState = {
  data: [],
  form: {},
  loading: false,
  error: null,
  totalElements: 0,
};

export default function equipamento(state = initialState, action) {
  switch (action.type) {
    case ACTION.EQUIPAMENTO_GET_SEARCH_PAGE:
    case ACTION.EQUIPAMENTO_GET_ALL_REQUEST:
    case ACTION.EQUIPAMENTO_POST_REQUEST:
    case ACTION.EQUIPAMENTO_GET_ID_REQUEST:
    case ACTION.EQUIPAMENTO_UPDATE_REQUEST:
    case ACTION.EQUIPAMENTO_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTION.EQUIPAMENTO_GET_ALL_SUCCESS: {
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    }
    case ACTION.EQUIPAMENTO_GET_SEARCH_PAGE_SUCCESS: {
      const { content, totalElements } = action.data;
      return {
        ...state,
        loading: false,
        error: null,
        data: (content || []).map(row => ({ ...row, key: row.id })),
        totalElements,
      };
    }
    case ACTION.EQUIPAMENTO_POST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ACTION.EQUIPAMENTO_UPDATE_SUCCESS:
    case ACTION.EQUIPAMENTO_GET_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.data,
      };
    case ACTION.EQUIPAMENTO_DELETE_SUCCESS:
      return {
        ...state,
      };
    case ACTION.EQUIPAMENTO_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
